import en from './en-US';

export default {
  ...en,
  service_promise_paragraph_part_2:
    'I, on behalf of Customer, agree to the Terms and Conditions of the Service Agreement(s) and am authorized to do so.',
  terms_acknowledgement:
    'I, on behalf of Customer, agree to the Terms and Conditions of the Service Agreement(s) and am authorized to do so.'
};
